/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import ErrorLayout from 'layouts/ErrorLayout';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.closeError = this.closeError.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error:', error, errorInfo);
  }

  closeError() {
    this.setState({ hasError: false });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <ErrorLayout code={500} onNavigate={this.closeError} />;
    }
    return children;
  }
}

export default ErrorBoundary;
